/** Matches `/visit/consent/<token>` (token must be non-empty; no extra path segments). */
const VISITOR_CONSENT_PUBLIC_PATH = /^\/visit\/consent\/[^/]+$/;

export const isVisitorConsentPublicPath = (pathname: string): boolean =>
  VISITOR_CONSENT_PUBLIC_PATH.test(pathname);
